<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
	 :close-on-click-modal="false">
		<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="标题:" label-width="150px" prop="title" class="notBlank">
				<el-input v-model="addForm.title" auto-complete="off" class="formItem" maxLength="50"  size="small"/>
			</el-form-item>
			<el-form-item label="图片:" label-width="150px" class="notBlank">
				<upload_single @callBack="uploadCallBack" :url="addForm.picUrl"></upload_single>
			</el-form-item>
			<el-form-item label="链接路径:" label-width="150px" prop="linkUrl">
				<el-input v-model="addForm.linkUrl" auto-complete="off" class="formItem" maxLength="200" size="small" style="width:300px;"/>
			</el-form-item>
			<el-form-item label="广告代码:" label-width="150px" prop="positionCode" class="notBlank">
				<el-input v-model="addForm.positionCode" auto-complete="off" class="formItem150" size="small" maxLength="50" />
			</el-form-item>
			<el-form-item label="位置名称:" label-width="150px" prop="positionName" class="notBlank">
				<el-input v-model="addForm.positionName" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
			<el-form-item label="位置描述:" label-width="150px" prop="positionDesc">
				<el-input v-model="addForm.positionDesc" auto-complete="off" class="formItem"  size="small" maxLength="300" />
			</el-form-item>
			<el-form-item label="广告宽度:" label-width="150px" prop="width" class="notBlank">
				<el-input v-model="addForm.width" auto-complete="off" class="formItem150"  size="small" maxLength="50" />
			</el-form-item>
			<el-form-item label="广告高度:" label-width="150px" prop="height" class="notBlank">
				<el-input v-model="addForm.height" auto-complete="off" class="formItem150" size="small" maxLength="50" />
			</el-form-item>
			<el-form-item label="显示:" label-width="150px" prop="isShow">
				<el-checkbox v-model="addForm.isShow" :true-label="1" :false-label="0" size="small"></el-checkbox>
			</el-form-item>
			<el-form-item label="内容:" label-width="150px" prop="content" v-if="1==2">
				<vue-editor v-model="addForm.content" height="450px" :editor-toolbar="customToolbar" />
			</el-form-item>

		</el-form>

		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
import upload_single from '@/components/upload_single.vue';
	export default {
		name: "addSave",
		props: ["showTitle", "dialogAddShow", "mid"],
		components: { upload_single },
		data() {
			return {
				editorConfig: {
                    // The configuration of the editor.
                    language: 'zh-cn'
                },
				addForm: {},
				roleIDsDict: [],
				userRules: {},
				dialogImageUrl: '',
				customToolbar: [["bold", "italic", "underline"],[{ list: "ordered" }, { list: "bullet" }]]
			};
		},
		watch: {
			dialogAddShow: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.initData();
					}
				},
				deep: true
			}
		},
		methods: {
			uploadCallBack(url){
				this.addForm.picUrl=url
			},
			async uploadFile(file){
				let result=await this.uploadOssFile(file)
				if(result!=null){
					this.dialogImageUrl=result[1]
					this.addForm.picUrl=result[0]
				}
				else{
					this.$message('上传失败！')
				}
		
			},
			initData() {
				this.$axios.get("/basic/getadvertisementinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
					.then(res => {
						this.addForm = res.data.data;
						if(this.addForm.picUrl!=""){
							this.dialogImageUrl=this.$util.webRoot+this.addForm.picUrl;
						}
						else{
							this.dialogImageUrl="";
						}
						this.loadDict();
					});
				
			},
			loadDict() {},
			handleClose() {
				this.$emit("getVisible", false);
			},
			handleSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						let formData = this.$util.jsonToForm(this.addForm);
						this.$axios.post("/basic/advertisementsave", formData).then(res => {
							if (res.data.status == 0) {
								this.$message("保存成功!");
								this.$emit("saveCallBack");
							} else {
								this.$message(res.data.msg);
							}
						});

					} else {
						return false;
					}
				});
			}
		}
	};
</script>

<style lang="scss" scoped>

</style>
